import { combineReducers } from "redux";

// -------------------------------------Home
import why_choose_us from "../features/admin/website/home/why_choose_us/slice";
import who_we_are from "../features/admin/website/home/who_we_are/slice";
import SuccessSpeaks from "../features/admin/website/home/SuccessSpeaks/slice";
import faq from "../features/admin/website/home/faq/slice";

// About Us
import ourStory from "../features/admin/website/aboutus/ourStory/Slice";

// Contact Us
import get_in_touch from "../features/admin/website/contact_us/get_in_touch/Slice";

const website = combineReducers({
  why_choose_us: why_choose_us,
  who_we_are: who_we_are,
  SuccessSpeaks: SuccessSpeaks,
  faq: faq,

  //About us

  ourStory: ourStory,

  //Contact us

  get_in_touch: get_in_touch,
});

export default website;
